import { IMerchant } from "models/Merchant";
import { IUsage } from "../../../extra-actions/apis/get-merchants-usages-by-merchant-id";

export enum LimitationType {
  Device = "device",
  User = "user",
  Event = "event",
  Notification = "notification",
}

export enum LimitationTimeFrames {
  Years = "years",
  Months = "months",
  Days = "days",
  Hours = "hours",
  Minutes = "minutes",
  CurrentDay = "currentDay",
  CurrentWeek = "currentWeek",
  CurrentMonth = "currentMonth",
  CurrentYear = "currentYear",
}

export interface ITimeFrame {
  type: LimitationTimeFrames;
  amount?: number;
}

export interface ILimitation {
  type: LimitationType;
  threshold: number;
  timeFrame?: ITimeFrame;
}

export interface MerchantState {
  list: IMerchant[];
  usages: IUsage[];
  isCreateMerchantDialogOpen: boolean;
  isCreateMerchantBannerDialogOpen: boolean;
  isCreateDefaultEventDialogOpen: boolean;
}

export type SetIsCreateMerchantDialogOpenAction = {
  payload: boolean;
};

export type SetIsCreateMerchantBannerDialogOpenAction = {
  payload: boolean;
};

export type SetIsCreateDefaultEventDialogOpenAction = {
  payload: boolean;
};
